/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LoadingCondition {
  BALLASTED = 'Ballasted',
  LOADED = 'Loaded',
  HALF_LADEN = 'Half laden',
}
